"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CloseableTipAlert;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TipAlert = _interopRequireDefault(require("./TipAlert"));

var _useUserAttribute3 = _interopRequireDefault(require("../hooks/useUserAttribute"));

function CloseableTipAlert(props) {
  var getUserAttributes = props.getUserAttributes,
      setUserAttribute = props.setUserAttribute,
      attributeKey = props.attributeKey,
      rest = (0, _objectWithoutProperties2.default)(props, ["getUserAttributes", "setUserAttribute", "attributeKey"]);

  var _useUserAttribute = (0, _useUserAttribute3.default)(getUserAttributes, setUserAttribute, attributeKey),
      _useUserAttribute2 = (0, _slicedToArray2.default)(_useUserAttribute, 3),
      attributeLoaded = _useUserAttribute2[0],
      hasAttribute = _useUserAttribute2[1],
      setHasAttribute = _useUserAttribute2[2];

  if (!attributeLoaded || hasAttribute) {
    return null;
  }

  return _react.default.createElement(_TipAlert.default, Object.assign({}, rest, {
    closeable: true,
    onClose: function onClose() {
      return setHasAttribute(true);
    }
  }));
}

CloseableTipAlert.propTypes = Object.assign({}, _TipAlert.default.propTypes, {
  getUserAttributes: _propTypes.default.func.isRequired,
  setUserAttribute: _propTypes.default.func.isRequired,
  attributeKey: _propTypes.default.string.isRequired
});
module.exports = exports.default;